var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 24C5.38078 24 0 18.6192 0 12C0 5.38084 5.38078 0 11.9999 0C15.0353 0 17.8836 1.10243 20.1027 3.13665C19.3646 3.57312 18.6523 4.05658 17.9672 4.57989C16.2857 3.22337 14.195 2.4765 11.9999 2.4765C6.75415 2.4765 2.4765 6.75421 2.4765 12C2.4765 17.2458 6.75415 21.5235 11.9999 21.5235C19.299 21.5235 23.6324 13.7214 20.493 7.65517C20.9688 7.21271 21.4586 6.78384 21.9612 6.36929C22.1096 6.24687 22.2593 6.12561 22.4101 6.00556C23.4603 7.81941 24.0001 9.87599 24.0001 11.9999C24 18.6192 18.6192 24 11.9999 24Z",
    fill: "#9A9AB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3153 18.1688C12.1802 18.1688 12.0676 18.0788 12.0226 17.9662C12.0001 17.9212 10.0639 12.923 7.06949 11.0318C6.48411 10.6716 6.03392 10.2888 6.214 9.43328C6.39407 8.60027 6.95697 8.12747 7.97006 7.90232C9.77115 7.51956 11.7074 10.3113 12.4279 11.4596C14.9494 7.7898 19.9925 2.02613 27.3321 1.35072C27.6862 1.30921 27.8171 1.83405 27.4897 1.98111C27.3772 2.02613 16.8855 6.82173 12.6304 17.9887C12.5629 18.1012 12.4503 18.1688 12.3153 18.1688Z",
    fill: "#9A9AB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b773c25fa1730d244d0f76a3ee2297c7.svg";
export { ForwardRef as ReactComponent };